import create from "zustand"



const useStore = create((set) => ({
    storeUserData: (userData) => 
        set((state) => ({userData: userData})),
    userData: null,
}));


export default useStore;